import { useEffect, useState } from "react";
const hasWindow = typeof window !== "undefined";
const hasAgent = (agentString) => {
    if (hasWindow) {
        return window.navigator.userAgent.includes(agentString);
    }
    return false;
};
const isSafari = () => !hasAgent("Chrome") && hasAgent("Safari");
const getBrowserDetectionState = () => ({
    isIE: hasAgent("Trident"),
    isEdge: hasAgent("Edge"),
    isIE11: !hasAgent("Edge") && hasAgent("Trident"),
    // Use chrome as default for SSR
    isChrome: !hasWindow || hasAgent("Chrome"),
    isFirefox: hasWindow && /Gecko\/.*Firefox\//.test(window.navigator.userAgent),
    isSafari: isSafari(), // TODO: consider merging with webview in the next major release
    isMac: hasWindow && /Mac OS/.test(window.navigator.userAgent) && !/Mobile/.test(window.navigator.userAgent),
    isIOSWebView: hasWindow && !isSafari() && /iphone|ipod|ipad/i.test(window.navigator.userAgent)
});
export const useBrowserDetection = () => {
    const [browserState, setBrowserState] = useState(getBrowserDetectionState());
    useEffect(() => {
        if (process.env.NODE_ENV === "test") {
            return;
        }
        setBrowserState(getBrowserDetectionState());
    }, []);
    return browserState;
};
